import { domain } from "./APIConstant";

export const routeBlogApi = {
    main: domain + '/api/blog'
}